import { render, staticRenderFns } from "./SearchResultGroupItem.vue?vue&type=template&id=d83b0704&scoped=true&"
import script from "./SearchResultGroupItem.vue?vue&type=script&lang=js&"
export * from "./SearchResultGroupItem.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultGroupItem.vue?vue&type=style&index=0&id=d83b0704&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83b0704",
  null
  
)

export default component.exports